import { Alert, AlertTitle, styled } from "@mui/material";
import { WarningAmber as WarningAmberIcon } from '@mui/icons-material';
import { useTranslation } from "react-i18next";
import { useReservationFormMachines } from "../ReservationFormMachinesContext";
import { LevelOfCareContext } from "../machines/levelOfCare.machine";
import { useFieldActorSnapshot } from "../useFieldActorSnapshot";

const StyledMessage = styled(Alert)(({ theme }) => ({
  maxWidth: 400,
  transition: 'all 0.2s ease-in-out',
}));

const NeedsApprovalMessage = ({ index }: { index: number }) => {
  const { t } = useTranslation('common');

  const { fieldRefs } = useReservationFormMachines();
  const levelOfCareActor = fieldRefs.levelOfCare;
  const levelOfCareSnapshot = useFieldActorSnapshot(levelOfCareActor);
  const { isGurneySelected } = levelOfCareSnapshot.context as LevelOfCareContext;

  if (!isGurneySelected[index]) {
    return null;
  }

  return (
    <StyledMessage
      icon={<WarningAmberIcon color="error" />}
      severity={'error'}>
      <AlertTitle>
        <strong>{t('reservation.needsApproval')}</strong>
      </AlertTitle>
      {t('reservation.beriaticGurneyApprovalMessage')}
    </StyledMessage>
  );
};

export { NeedsApprovalMessage };